import { render, staticRenderFns } from "./courseMould.vue?vue&type=template&id=d5f7e6d4&scoped=true&"
import script from "./courseMould.vue?vue&type=script&lang=js&"
export * from "./courseMould.vue?vue&type=script&lang=js&"
import style0 from "./courseMould.vue?vue&type=style&index=0&id=d5f7e6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f7e6d4",
  null
  
)

export default component.exports